import { render, staticRenderFns } from "./RegionCriteriaCard.vue?vue&type=template&id=faf02edc&scoped=true&"
import script from "./RegionCriteriaCard.vue?vue&type=script&lang=js&"
export * from "./RegionCriteriaCard.vue?vue&type=script&lang=js&"
import style0 from "./RegionCriteriaCard.vue?vue&type=style&index=0&id=faf02edc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf02edc",
  null
  
)

export default component.exports